module.exports = __webpack_public_path__ + "static/media/double_bet_first.c11d020d.mp3";